// extracted by mini-css-extract-plugin
export default {"textAreaStyles":"pure-text-area_textAreaStyles__t8puV"};